import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import axios from 'axios';

export const useFavoriteProductsStore = create(
  devtools((set, get) => ({
    favoriteProductsCount: 0,
    favoriteProductIds: [], // Для локальної перевірки статусу

    loadFavoriteProductsCount: async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        set(() => ({ favoriteProductsCount: 0 }));
        return;
      }

      try {
        const res = await axios.get('/api/v1/product-favorite/count', {
          headers: {
            Authorization: token,
          },
        });
        if (res.status === 200 && res.data.data !== undefined) {
          set(() => ({ favoriteProductsCount: res.data.data }));
        }
      } catch (error) {
        console.error('Error loading favorite products count:', error);
        set(() => ({ favoriteProductsCount: 0 }));
      }
    },

    setFavoriteProductIds: (ids) => {
      set(() => ({ favoriteProductIds: ids }));
    },

    addFavoriteProduct: (productId) => {
      const currentIds = get().favoriteProductIds;
      if (!currentIds.includes(productId)) {
        set(() => ({ favoriteProductIds: [...currentIds, productId] }));
        // Оптимістичне оновлення кількості (без API виклику)
        set(state => ({ favoriteProductsCount: state.favoriteProductsCount + 1 }));
      }
    },

    removeFavoriteProduct: (productId) => {
      const currentIds = get().favoriteProductIds;
      if (currentIds.includes(productId)) {
        set(state => ({
          ...state,
          favoriteProductIds: state.favoriteProductIds.filter(id => id !== productId),
          favoriteProductsCount: Math.max(0, state.favoriteProductsCount - 1),
        }));
        // Оптимістичне оновлення кількості (без API виклику)
      }
    },

    clearFavorites: () => {
      set(() => ({ favoriteProductIds: [], favoriteProductsCount: 0 }));
    },
  })),
);
